import "./auth-pages.scss";

import { useDispatch } from "react-redux";

import { logout } from "shared/actions/authActions";
import { usePerformAfterInactivity } from "shared/hooks/useInteractionListener";
import { SUPPORT_EMAIL_MAILTO } from "shared/utils/siteConstants";

import MfaMethodSelectionForm from "components/MfaMethodSelectionForm";
import dotLogoSrc from "images/PathologyWatch_Dot_Logo_w Pw.png";
import { AppDispatch } from "store/store";

import ToastList from "../toasts/ToastList";

const MfaMethodSelectionPage = () => {
  const dispatch = useDispatch<AppDispatch>();

  usePerformAfterInactivity(() => {
    dispatch(logout());
  }, 2 * 60 * 1000); // logout after two minutes of inactivity

  return (
    <>
      <ToastList />
      {/* Specifying height: 100vh; in CSS doesn't work right on mobile devices with Chrome or Safari,
            because they don't take the address bar height into account.
            Ref https://chanind.github.io/javascript/2019/09/28/avoid-100vh-on-mobile-web.html */}
      <main className="auth-pages" style={{ maxHeight: window.innerHeight }}>
        <div className="auth-pages__content">
          <figure className="DotLogo">
            <img src={dotLogoSrc} alt="dot. by PathologyWatch" />
          </figure>
          <div className="form-div">
            <MfaMethodSelectionForm
              required
              onCancel={() => dispatch(logout())}
            />
          </div>
          <p>
            PathologyWatch uses a digital software platform independently
            validated as a laboratory-developed test. The systems referenced are
            currently neither FDA cleared nor approved for primary diagnosis.
          </p>
          <footer>
            <a href={SUPPORT_EMAIL_MAILTO}>Help</a>
            &nbsp;&ndash;&nbsp;
            <a href="https://pathologywatch.com">About&nbsp;Us</a>
          </footer>
        </div>
      </main>
    </>
  );
};

export default MfaMethodSelectionPage;
